import instance from '../axios';

export const getProvinces = async () => {
    const response =  await instance.get('region/provinces')
    return response.data.data;
}

export const getCustomCities = async () => {
    const response =  await instance.get('region/customcities')
    return response.data.data;
}

export const getCities = async (provinceId) => {
    const response = await instance.get(`region/cities?provinceId=${provinceId}`)
    return response.data.data;
}

export const getDistricts = async (cityId) => {
    const response = await instance.get(`region/districts?cityId=${cityId}`)
    return response.data.data;
}

export const getSubDistricts = async (districtId) => {
    const response = await instance.get(`region/subdistricts?districtId=${districtId}`)
    return response.data.data;
}